// ===== 1. Imports =====
import React from "react";

// ===== 2. Componente Principal =====
export default function Modal({
  title,
  children,
  onClose,
  className = "",
  style = {}, // <-- añadimos esto
}) {
  return (
    <div
      className="modal-backdrop"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowY: "auto",
      }}
    >
      <div
        className={`modal ${className}`}
        style={{
          background: "var(--background, #fff)",
          borderRadius: 12,
          padding: 24,
          maxWidth: "90vw",
          maxHeight: "90vh",
          overflowY: "auto",
          ...style, // <-- aplicamos el estilo que llega desde fuera
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ===== 3. Cabecera ===== */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <h2 style={{ margin: 0 }}>{title}</h2>
          <button
            className="button button--ghost"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        {/* ===== 4. Contenido ===== */}
        <div>{children}</div>
      </div>
    </div>
  );
}
